(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-metafield-table"] && !Shopify.designMode) return;
  try {
    (function () {
    function syncDesktop() {
      var els = document.querySelectorAll('.product-metafield-table-block--mobile-accordion');
      if (!els.length) return;
      var mql = window.matchMedia('(min-width: 768px)');
      function update() {
        if (mql.matches) {
          els.forEach(function (el) { el.open = true; });
        }
      }
      mql.addEventListener('change', update);
      update();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncDesktop);
    } else {
      syncDesktop();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
